"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1Strong: function() {
        return _Caption1Strong.Caption1Strong;
    },
    caption1StrongClassNames: function() {
        return _useCaption1StrongStylesstyles.caption1StrongClassNames;
    }
});
const _Caption1Strong = require("./Caption1Strong");
const _useCaption1StrongStylesstyles = require("./useCaption1StrongStyles.styles");
